import type { ApolloClient } from "@apollo/client";
import type { ContractStatusType, UserRole } from "@/gql/graphql";

export type GlobalSearchApolloClient = Pick<ApolloClient, "query">;

export const SEARCH_CATEGORY = [
  "contracts",
  "devices",
  "customers",
  "dealers",
  "invoices",
] as const;

export type SearchScope = (typeof SEARCH_CATEGORY)[number];

export function isSearchScope(value: string): value is SearchScope {
  return (SEARCH_CATEGORY as readonly string[]).includes(value);
}

export type ContractOptionProps = {
  options: ContractAutocompleteOptions[];
  totalCount: number;
  searchTerm: string;
  onViewAll?: () => void;
};

export type DevicesOptionProps = {
  options: DevicesAutocompleteOptions[];
  totalCount: number;
  searchTerm: string;
  onViewAll?: () => void;
};

export type ContractAutocompleteOptions = {
  contractNumber?: string;
  customerName?: string;
  contractStatus?: ContractStatusType;
  contractId?: string;
  purchaseOrderNumber?: string;
};

export type DevicesAutocompleteOptions = {
  deviceId: string;
  deviceName: string;
  deviceSerialNumber?: string;
  devicePartNumber?: string;
  deviceReference?: string;
  iconUrl: string;
};

export type DealerAutocompleteOptions = {
  dealerId: string;
  dealerName: string;
  dealerEmail: string;
};

export type DealerOptionProps = {
  options: DealerAutocompleteOptions[];
  searchTerm: string;
  onViewAll?: () => void;
};

export type InvoiceAutocompleteOptions = {
  invoiceId: string;
  contractNumber: string;
  customerName: string;
  purchaseOrderNumber: string;
  createdDate: string;
};

export type InvoiceOptionProps = {
  options: InvoiceAutocompleteOptions[];
  totalCount: number;
  searchTerm: string;
  onViewAll?: () => void;
};

export type CustomerCompanyOption = {
  customerId: string;
  companyName: string;
  ownerEmail: string | null;
};

export type CustomerRoleOption = {
  customerId: string;
  customer: {
    firstName: string;
    lastName: string;
    email: string;
    role?: UserRole;
  };
};

export type CustomerSearchItems = {
  companyOptions: CustomerCompanyOption[];
  roleOptions: CustomerRoleOption[];
};

export type CustomerOptionProps = CustomerSearchItems & {
  totalCount: number;
  searchTerm: string;
  onViewAll?: () => void;
};

export type ViewAllOptionProps = {
  totalCount: number;
  onViewAll?: () => void;
  searchCategory: SearchScope;
};
